<!doctype html>
<html lang="de" class="dark m-0 h-full">
<head>
    <meta charset="UTF-8"/>
    <link rel="icon" type="image/svg+xml" href="assets/diredawn_icon.png"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>DireDawn</title>
</head>
<body class="m-0 h-full overflow-hidden">
<div id="root" class="h-full"></div>
<script type="module" src="./src/main.tsx"></script>
</body>
</html>
